import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ClientProfileComponent } from '@brightnav/ui';
import { ReviewQueueComponent } from '@brighthub/ai-review-ui';
import { ScrollRegionComponent } from '@brightside/angular-bds';
import { TabBarComponent, TabItem } from '../tab-bar/tab-bar.component';
import { FinancesTabComponent } from '../finances-tab/finances-tab.component';
import type { FaAppTabId } from '../fa-tabs';

/**
 * Client Info pane: header, tab bar, and tab bodies for FA layout.
 * Layout owns splitter / collapse strips; this owns the content column chrome.
 */
@Component({
  selector: 'bn-fa-client-info-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ClientProfileComponent,
    FinancesTabComponent,
    ReviewQueueComponent,
    TabBarComponent,
    ScrollRegionComponent,
  ],
  templateUrl: './fa-client-info-panel.component.html',
  host: {
    class: 'flex flex-col min-h-0 overflow-hidden h-full w-full',
  },
})
export class FaClientInfoPanelComponent {
  readonly tabs = input.required<TabItem[]>();
  readonly activeTabId = input.required<FaAppTabId>();
  readonly mandatoryTabIds = input<FaAppTabId[]>([]);
  /** Client GUID for the Review tab; null when no client is selected. */
  readonly clientGuid = input<string | null>(null);
  /** Display name for the Review tab header / detail dialog. */
  readonly clientName = input<string | null>(null);

  readonly tabSelect = output<string>();
  readonly collapseContent = output<void>();
  readonly needsAttention = output<boolean>();
}
